// pipe: 4B.6 (Task 10) — Operations sidebar entry (links to the Ops Dashboard; its per-stage tiles
// deep-link to the stage worklists). Cloned from records-button.tsx (verbatim shape) — only the
// route, the active-path prefix, the label key, and the testid differ.
import { useI18n } from '@affine/i18n';
import { DatabaseTableViewIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const OpsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // [C-9] REACTIVE active state: any `/ops/*` route (dashboard + worklist) keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/ops');

  return (
    <MenuLinkItem
      icon={<DatabaseTableViewIcon />}
      active={active}
      to={'/ops/dashboard'}
    >
      <span data-testid="pipe-ops-nav">{t['com.affine.pipe.ops.nav']()}</span>
    </MenuLinkItem>
  );
};
